<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
        <v-card
            class="mt-7"
            width="500"
        >  
           
            <v-toolbar 
                color="primary"
                dark
            >
                <v-toolbar-title>Term Reports</v-toolbar-title>  
            </v-toolbar>
            <v-list two-line>
                <v-list-item-group
                    v-model="selected"
                    active-class="primary--text"                    
                >
                    <template v-for="(item, index) in items">
                        <v-list-item 
                            :key="item.id" 
                            @click="displayReport(item)"
                            :disabled="!item.posted"
                            :filled="!item.posted"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>

                                    <v-list-item-subtitle
                                        class="text--primary"
                                        v-text="item.headline"
                                    ></v-list-item-subtitle>                                  

                                   
                                    <v-list-item-subtitle
                                        v-text="item.subtitle"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                                    <v-icon
                                        v-if="!active"
                                        color="grey lighten-1"
                                    >
                                        mdi-star-outline
                                    </v-icon>

                                    <v-icon
                                        v-else
                                        color="yellow darken-3"
                                    >
                                        mdi-star
                                    </v-icon>

                                </v-list-item-action>

                                

                            </template>
                        </v-list-item>

                        <v-divider
                            v-if="index < items.length - 1"
                            :key="index"
                        ></v-divider>

                    </template>
                </v-list-item-group>
            </v-list>
            
        </v-card>
        </v-row>
        
        
        <v-dialog
            v-model="reportCard"
            max-width="700px"
            @click:outside="closeReport"
        >
            <v-card
               height="90vh" 
            >                
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:100%" 
                    class="report-viewer" 
                    :src="src"
                ></iframe>              
                <v-overlay
                    absolute
                    :value="reportViewerOverlay"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>     
            </v-card>
        </v-dialog>        
    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'TermReport',
    components: {
        Layout,
    },

    created(){
        this.initialize();
    },
    
    data: () => ({
        reportCard: false,
        selected: -1,
        items: [],
        src: '',
        reportViewerOverlay: false,        
    }),

    computed:{
        ...mapGetters({
            user: 'auth/getUser',
            studentId: 'auth/getUserId',
            reportTerms: 'report/getReportTerms'                    
        }),
    },
    methods: {
        ...mapActions({
            getAcademicTerms: 'report/getAcademicTerms',
        }),
        
        ...mapMutations({
            setOverlay: 'auth/setOverlay',
        }),

        displayReport(item){           
            let term_id = item.term;
            let form_class_id = item.form_class_id;
            this.reportCard = true;
            this.reportViewerOverlay = true;
            this.$nextTick( function () {            
                this.$refs.pdf.onload = () => {
                    console.log('report is loaded');
                    this.reportViewerOverlay = false;
                }
            })
            if(item.report == 'end-of-term')              
            this.src = process.env.VUE_APP_API_URI + "/api/report-card/"+ term_id + "/" + form_class_id +  "/" + this.studentId;
            else if (item.report == 'mid-term'){
                this.src = process.env.VUE_APP_API_URI + 
                "/api/report-card/"+ 
                term_id + "/" 
                + form_class_id +  "/" 
                + this.studentId + "/mid-term";
            }
            
            console.log(this.src);
        },
        async initialize(){
            this.setOverlay(true);
            await this.getAcademicTerms({ id: this.studentId });
            //console.log(this.reportTerms);
            let reportId = 100;
            this.reportTerms.forEach(term => {
                reportId++;
                let postedMidTerm = false;
                let postedEndOfTerm = false;
                let midTermAction = "Not Available";
                let endOfTermAction = "Not Available";

                if(term.posted_mid_term){
                    postedMidTerm = true;
                    midTermAction = "Available";
                } 

                if(term.posted_end_of_term){
                    postedEndOfTerm = true;
                    endOfTermAction = "Available";
                }

                if(term.reports > 1){
                    this.items.push({
                        id: reportId,
                        title: 'Form ' + term.form_level,
                        action: endOfTermAction,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        report: 'end-of-term',
                        posted: postedEndOfTerm,
                    })

                    reportId++;

                    this.items.push({
                        id: reportId,
                        title: 'Form ' + term.form_level,
                        action: midTermAction,
                        headline: 'Mid Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        report: 'mid-term',
                        posted: postedMidTerm,
                    })
                }
                else{
                     this.items.push({
                        id: reportId,
                        title: 'Form ' + term.form_level,
                        action: endOfTermAction,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        report: 'end-of-term',
                        posted: postedEndOfTerm,
                    })
                }
               
            });
            this.setOverlay(false);
            console.log(this.items);
        },
        closeReport(){
            console.log('report closing ...');
            this.src = '';
            this.selected = -1;
        }
    }
   
    
}
</script>

<style scoped>
    ::v-deep .v-list-item.v-list-item--disabled.v-list-item--link.theme--light {
        background: gainsboro;
    }
</style>